import { colors } from '@material-ui/core'

const styles = (theme) => ({
  informationPaper: {
    backgroundColor: colors.grey[100],
  },
})

export default styles
